<template lang="pug">
  .page(v-if="feature")
    //-section(v-if="company.isMember")
      .max-width
        .row.apart
          .col
          .col
            router-link.button(:to="{ name: 'BoardSettingsGeneral', params: { boardSlug: board.slug }}") Settings

    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminBoard' : 'PublicBoard', params: { boardSlug: board.slug}}") {{ board.name }}
            li
              span \
            li.selected
              span {{ feature.name }}

        .fw--back-button(v-else)
            router-link.button(:to="{ name: 'PublicBoard', params: { boardSlug: board.slug}}")
              font-awesome-icon.icon(:icon="['fas', 'arrow-left']")
              span {{ board.name }}


    section
      .max-width
        .row
          .col.max
            BoardFeatureSelected()

            .feature-tags
              .tags
                .tag(v-for="tag in feature.tags")
                  span {{ tag.tag }}
                  span.delete-tag(v-if="company.isMember && $route.name === 'AdminFeature'", @click="deleteTag(tag)")
                    font-awesome-icon(:icon="['fa', 'times-circle']")

            .feature-tabs
              .tabs
                .tab.primary-text(@click="selectTab('comments')", :class="{active: selectedTab === 'comments'}")
                  span {{ textCommentsTab }}
                .tab.primary-text(@click="selectTab('votes')", :class="{active: selectedTab === 'votes'}")
                  span {{ textVotesTab }}

              .feature-tab-comments(v-if="selectedTab === 'comments'")
                .post(v-if="!feature.final && !selected.isReadOnly")
                  CommentForm
                .activities
                  .activity(v-for="activity in filteredActivities")
                    component(:is="activityMapper[activity.type]", :activity="activity", :key="activity._id", :isReadOnly="selected.isReadOnly")

              .feature-tab-votes(v-if="selectedTab === 'votes'")
                div.feature-vote(v-for="like in likes")
                  .row.center.apart
                    .col
                      .row.center
                        .col.feature-vote-avatar
                          UserAvatar(:user="like.user")
                        .col
                          span {{ like.user.fullName }}
                    .col
                      span.created {{ like.created | moment("from") }}

          .col.sidebar
            aside
              .aside-readonly(v-if="selected.isReadOnly")
                AlertBox(type="info", text="This feature has been merged into another and is in Read Only mode.")


              .member(v-if="company.isMember && $route.name === 'AdminFeature'")

                .form-field
                  button.button(type="button", @click="unmergeFeature", v-if="selected.isReadOnly")
                    span Unmerge Feature

                FeatureStatus

                FeatureAssign

                FeatureTag(@addTag="addTag")

                FeatureMerge(:board="feature.board")

                FeatureMove(v-if="boards.length > 1", :featureBoard="feature.board")

                .form-field
                  button.button(type="button", @click="confirmDelete", :disabled="selected.isReadOnly")
                    span Delete Feature

              .aside-notifications(v-if="!selected.isReadOnly")
                .form-field.no-margin
                  .form-field-toggle
                    p Stay up to date on the activity of this feature.
                    label.toggle-switch
                      .row.center
                        .col
                          input(type="checkbox", v-model="isWatched", @change="toggleIsWatched")
                          .toggle-switch-slider
                            .toggle-switch-knob
                        .col
                          div
                            span Receive notifications

              //-.aside-add-feature
                p Not what you had in mind?
                button.button(@click="showAddFeature") Add Feature


</template>

<script>

import { mapGetters, mapState } from 'vuex'
import { form } from '@/mixins/form'

import { ActivityComment, ActivityAssigned, ActivityStatusUpdated, ActivityMoved, ActivityLinked } from '@/components/activities'

import FeatureStatus from '@/components/feature/FeatureStatus'
import FeatureAssign from '@/components/feature/FeatureAssign'
import FeatureTag from '@/components/feature/FeatureTag'
import FeatureMove from '@/components/feature/FeatureMove'
import FeatureMerge from '@/components/feature/FeatureMerge'

import { required } from 'vuelidate/lib/validators'

import BoardFeatureSelected from '@/components/BoardFeatureSelected'
import CommentForm from '@/components/CommentForm'
import FormUpload from '@/components/form/FormUpload'

import SelectInput from '@/components/helpers/SelectInput'

//console.log(ActivityComponents)

const activityMapper = {
  comment: 'ActivityComment',
  assigned: 'ActivityAssigned',
  status_updated: 'ActivityStatusUpdated',
  moved: 'ActivityMoved',
  linked: 'ActivityLinked',
  unlinked: 'ActivityLinked'
}

export default {
  name: 'Feature',
  components: {
    ActivityComment, ActivityAssigned, ActivityStatusUpdated, ActivityMoved, ActivityLinked,
    FormUpload,
    SelectInput,
    BoardFeatureSelected,
    CommentForm,
    FeatureStatus, FeatureAssign, FeatureTag, FeatureMove, FeatureMerge
  },
  mixins: [form],
  beforeMount () {
    this.$store.commit('boards/SELECT_BOARD', this.$route.params.boardSlug)
    //this.$store.dispatch('features/getFeatures')
    this.$store.dispatch('features/getFeature', this.$route.params.featureSlug)
      .then(feature => {
        this.isWatched = feature.isWatched
        this.feature = feature
        //this.updateStatusForm.status = Object.assign({}, feature.status)
      }, error => {
        console.log('error')
        this.$router.push({ name: 'PublicDashboard' })
      })
    //this.$store.commit('features/SELECT_FEATURE', this.$route.params.featureSlug)
    this.$store.dispatch('features/getLikes', this.$route.params.featureSlug)
    this.$store.dispatch('activities/getActivities', this.$route.params.featureSlug)
  },
  data () {
    return {
      activityMapper,
      assignedTo: {
        _id: null
      },
      assignedBoard: {
        _id: null
      },
      formState: 'initial',
      form: {
        comment: '',
        attachments: null
      },
      feature: null,
      isWatched: false,
      selectedTab: 'comments'
    }
  },
  validations: {
    form: {
      comment: {
        required
      }
    }
  },
  mounted () {

  },
  computed: {
    ...mapState({
      company: state => state.company,
      boards: state => state.boards.list,
      activities: state => state.activities.list,
      statuses: state => state.statuses,
      likes: state => state.features.likes,
      users: state => state.users,
      selected: state => state.features.selected
    }),
    ...mapGetters({
      board: 'boards/selected'
    }),
    filteredActivities () {
      return this.activities.filter(activity => this.isAdmin || (!this.isAdmin && !activity.internal))
    },
    textCommentsTab () {
      return `${this.feature.stats.comments} Comment${this.feature.stats.comments === 1 ? '' : 's'}`
    },
    textVotesTab () {
      return `${this.likes.length} Vote${this.likes.length === 1 ? '' : 's'}`
    },
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    selectTab (tab) {
      this.selectedTab = tab
    },
    toggleIsWatched () {
      if (this.isWatched) {
        this.$store.dispatch('features/watchFeature', this.feature.slug)
          .then(success => {
            //console.log('success', success)
          }, () => {
            this.isWatched = false
            //console.log('error', error)
          })
      } else {
        this.$store.dispatch('features/unwatchFeature', this.feature.slug)
      }
    },
    confirmDelete () {
      this.$DialogBox.open({
        parent: this,
        open: true,
        header: 'Delete Feature?',
        message: 'Just double checking!',
        onConfirm: () => {
          this.deleteFeature()
        }
      })
    },
    deleteFeature () {
      let slug = this.feature.slug
      let board = this.feature.board
      this.$store.dispatch('features/deleteFeature', slug)
        .then(() => {
          this.$router.replace({
            name: 'AdminBoard',
            params: {
              boardSlug: board.slug
            }
          })
        })
    },
    unmergeFeature () {
      this.$DialogBox.open({
        parent: this,
        open: true,
        header: 'Unmerge Feature?',
        message: 'This will make it active again.',
        onConfirm: () => {
          console.log(this.feature)
          this.$store.dispatch('features/unmergeFeature', {
            slug: this.feature.slug,
            update: {
              link: this.feature.links[0]._id
            }
          })
          .then(() => {
          })
        }
      })

    },
    addTag (tag) {
      console.log(tag)
      this.feature.tags.push(tag)
    },
    deleteTag (tag) {
      let index = this.feature.tags.findIndex(t => t._id === tag._id)
      if (index > -1) {
        this.feature.tags.splice(index, 1)
        let updates = {
          slug: this.feature.slug,
          update: {
            tags: this.feature.tags
          }
        }
        this.$store.dispatch('features/updateFeature', updates)
      }
      // this.$store.dispatch('deleteTag', tag)
      //   .then(() => {
      //     let index = this.feature.tags.findIndex(t => t._id === tag._id)
      //     if (index > -1) {
      //       this.feature.tags.splice(index, 1)
      //     }
      //   })
    },
    showAddFeature () {
      alert('work in progress')
    }
  },
  watch: {
    'selected.isWatched' (val) {
      this.isWatched = val
    }
  }
}
</script>

<style lang="stylus" scoped>
  .fw--back-button
    margin-bottom $spacing-2

  .back
    padding $spacing-4 0

  .feature-tags
    margin-bottom $spacing-4
    .tags
      display flex
      .tag
        border 1px solid #e0dfde
        border-radius 18.5px
        font-size 12px
        padding 5px 10px
        margin-right $spacing
      .delete-tag
        cursor pointer
        margin-left 5px

  .feature-tags,
  .feature-tabs
    margin-left 80px
    +for_breakpoint(mobile)
      margin-left 0
    .tabs
      margin-bottom $spacing-4

  +for_breakpoint(mobile)
    .sidebar
      display none


  aside
    border $border-default
    border-radius $border-radius
    margin-left $spacing-3
    width 370px
  .member
    padding $spacing-3
  .aside-notifications
    padding $spacing-3
  .aside-readonly
    padding $spacing-3
    padding-bottom 0

  .aside-add-feature
    padding $spacing-3
    p
      margin-bottom $spacing

  .attachment-upload
    align-items center
    display flex
  .feature-tab-votes
    .feature-vote
      margin-bottom $spacing
    .feature-vote-avatar
      width 50px
    .created
      font-size $text-size-smaller
      line-height $text-size-default

</style>
